import React, { useEffect, useState } from 'react';

/**
 * Live date + time badge for the page header.
 *
 * Big day number on the left; weekday + "Mon YYYY" stacked next to it; live
 * 12-hour clock on the right. Updates once per second.
 */
export const DateTimeBadge: React.FC = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const day = now.getDate();
  const weekday = now.toLocaleDateString(undefined, { weekday: 'long' });
  const monthYear = now.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
  const time = now.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  return (
    <div
      role="status"
      aria-label={`${weekday}, ${monthYear} ${day}, ${time}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        color: 'white',
        minWidth: 'fit-content',
      }}
    >
      <div
        style={{
          fontSize: '26px',
          fontWeight: 700,
          lineHeight: 1,
          color: 'white',
        }}
      >
        {day}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
        <span style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{weekday}</span>
        <span style={{ fontSize: '11px', opacity: 0.7, color: 'white' }}>{monthYear}</span>
      </div>
      <div
        style={{
          fontSize: '14px',
          fontVariantNumeric: 'tabular-nums',
          fontWeight: 500,
          color: 'white',
          minWidth: '88px',
          textAlign: 'right',
        }}
      >
        {time}
      </div>
    </div>
  );
};
